<div class="input-email-wrapper">
    <input id="email" type="email"
           [formControl]="emailControl"
           [placeholder]="subtitles.setSubtitle(1110)"
           class="input-email"
           [ngClass]="{'input-email-error': isInvalid() }"
    />
    @if (isInvalid()) {
        <img [ngSrc]="'/assets/img/icons/red-alarm.svg'" class="alarm-icon"
             width="16" height="16" alt=""/>
        <div class="error-text-wrapper">
            @if (emailControl?.errors?.['required']) {
                <div>{{ subtitles.setSubtitle(5062) }}</div>
            }
            @if (emailControl?.errors?.['email']) {
                <div>{{ subtitles.setSubtitle(1342) }}</div>
            }
        </div>
    }
</div>
